import {
    FETCH_TICKET,
    LIST_TICKET,
    CLEAR_TICKET, DELETE_TICKET
} from "./types";

const init = {
    isLoading: false,
    data: {
        tickets: [],
        drawShifts: [],
        summary: {
            grandTotalUsd: {
                betAmount: 0,
                waterAmount: 0,
                winAmount: 0,
                winLoseAmount: 0
            },
            grandTotalKhr: {
                betAmount: 0,
                waterAmount: 0,
                winAmount: 0,
                winLoseAmount: 0
            }
        },
    },
    filter: {},
    page: 1,
    totals: 0,
    size: 50
};
export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_TICKET:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_TICKET:
            return {
                ...state,
                isLoading: false,
                ...payload
            };
        case DELETE_TICKET:
            return {
                ...state,
                isLoading: true
            };
        case CLEAR_TICKET:
            return {
                ...init
            };
        default:
            return state;
    }
}